export default __webpack_public_path__ + "static/media/beaver.b6fe26f0.png";